/** How many months back the "new invoice" month picker goes for month-to-month leases. */
export const INVOICE_MONTHS_BACK = 36;

/** Late fees are capped at this many days when offered. */
export const LATE_FEE_MAX_DAYS = 30;

/**
 * Late fee to OFFER (never auto-apply) for an invoice whose late date has passed.
 * rate is the lease's per-day late fee; days are capped at LATE_FEE_MAX_DAYS.
 */
export function suggestLateFee(lateDate: Date, now: Date, rate: number): { quantity: number, rate: number, amount: number } | null {
  if (!rate || !(now > lateDate)) {
    return null;
  }
  const days = Math.min(LATE_FEE_MAX_DAYS, Math.floor((now.getTime() - lateDate.getTime()) / 86400000));
  if (days <= 0) {
    return null;
  }
  return { quantity: days, rate, amount: days * rate };
}
